import axios from "axios";
import Vue from "vue";
import helper from "../../util/helper";

export default {
  state: () => ({
    selectedAccountApprove: {
      caseModelList: [],
    },
  }),

  mutations: {
    setSelectedAccountApprove(state, selectedAccountApprove) {
      Vue.set(state, "selectedAccountApprove", selectedAccountApprove);
    },
    setSearchAccountApproveArgument(state, accountApproveArgument) {
      Vue.set(state, "searchAccountApproveArgument", accountApproveArgument);
    },
    setDefaultAccountApproveModule(state, accountApproveArgument) {
      Vue.set(state, "selectedAccountApprove", {
        caseModelList: [],
      });
    },
  },

  actions: {
    searchAccountApproves: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/view-account/approve", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },

    approveAccount: (context, request) => {
      return axios
        .post(context.getters.getMcServiceUrl + "/cases/approve", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getSlipData: (context, serialNumber) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/slip-data", {
          params: {
            serialNumber,
          },
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getSlipDataByLocator: (context, locator) => {
      return axios
        .get(context.getters.getPoolExternalUrl + "/pex/slip-data/by-locator", {
          params: {
            locator,
          },
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getEndOfDaySlipsData: (context, request) => {
      return axios
        .post(context.getters.getCrsServiceUrl + "/slips/end-of-day-slips", request)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getAccountSummarySlipsData: (context, requestParams) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/account-summary/image", {
          params: requestParams,
          responseType: "json",
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getAccountSummarySlipPdf: (context, requestParams) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/account-summary/pdf", {
          params: requestParams,
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getPosSlipPdf: (context, serialNumber) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/pos-slip/pdf", {
          params: { serialNumber },
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
    getEndOfDaySlipPdf: (context, request) => {
      return axios
        .get(context.getters.getTmsServiceUrl + "/pdf/end-of-day-slip/pdf", {
          params: {
            userId: request.userId,
            startDate: request.startDate,
          },
        })
        .then((response) => {
          return response;
        })
        .catch((err) => {
          return err.response;
        });
    },
  },
  getters: {
    getSearchAccountApproveArgument: (state) => {
      return state.searchAccountApproveArgument;
    },
    getSelectedAccountApprove: (state) => {
      return state.selectedAccountApprove;
    },
  },
};
